module.exports = __webpack_public_path__ + "img/line-chart.ffbbd24b.svg";